import { Empty, theme, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomGlobalThemeToken } from 'src/common/themes';
import { Bell } from 'lucide-react';

const { Text } = Typography;

const { useToken } = theme;

export const NotificationsEmpty = () => {
  const { token } = useToken();
  const customToken = token as CustomGlobalThemeToken;
  const { t } = useTranslation();

  return (
    <div
      style={{
        backgroundColor: customToken.containerCardBg,
        height: 220,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Empty
        style={{ margin: 'auto', width: '100%' }}
        image={<Bell size={96} style={{ color: customToken.placeholderVectorColor }} />}
        description={
          <>
            <Text strong>{t('EmptyNotificationsTextTitle')}</Text>
            <br />
            <Text>{t('EmptyNotificationsTextSubtitle')}</Text>
          </>
        }
      />
    </div>
  );
};
